import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_card, { flat: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            (_ctx.title)
              ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, null, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", {
                          textContent: _toDisplayString(_ctx.title)
                        }, null, 8, _hoisted_1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { class: "pt-1 pb-1" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('filter.title')) + " ", 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (item) => {
                      return (_openBlock(), _createBlock(_component_v_chip, {
                        key: item.key,
                        closable: "",
                        filter: "",
                        small: "",
                        color: "secondary",
                        class: "ma-1",
                        "onClick:close": ($event: any) => (_ctx.chipClosed(item.key))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t(item.nameResourceKey)) + ": " + _toDisplayString(item.value), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick:close"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (!_ctx.downloadToolbar)
      ? (_openBlock(), _createBlock(_component_v_toolbar, {
          key: 0,
          density: "compact",
          class: "toolbar",
          flat: "",
          color: "white"
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ]),
          _: 3
        }))
      : (_openBlock(), _createBlock(_component_v_toolbar, {
          key: 1,
          density: "compact",
          flat: "",
          class: "toolbar text-white",
          color: "primary"
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ]),
          _: 3
        })),
    _createVNode(_component_v_divider)
  ]))
}